import IncidentForm, {IIncidentForm} from "../IncidentForm/IncidentForm";
import MainContainer from "../../../../components/ContainerComponents/MainContainer";
import HeaderContainer from "../../../../components/ContainerComponents/HeaderContainer";
import styles from './incidentContainer.module.scss'
import React from "react";

interface IIncidentContainer extends IIncidentForm{}

const IncidentContainer: React.FC<IIncidentContainer> = (props) => {
    return (
        <MainContainer className={styles.container}>
            <HeaderContainer title={props.isNewIncident ? "Nytt tillbud / olycka" : "Tillbud & Olyckor"}/>
            <IncidentForm
                {...props}
            />
        </MainContainer>
    )
}

export default IncidentContainer